import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Span from '@deliveroo/consumer-component-library/components/Span';
import Radio from '../Radio';

import styles from './styles.scss';

/**
 * FilterList: a component that accepts a vertical list of filters
 */
const FilterList = ({
  title,
  filters,
  selected,
  onSelect,
  resetLabel,
  isLabelLeft,
  id: parentId,
}) => (
  <React.Fragment>
    {title && (
      <span className={styles.title}>
        <Spacer spacing="medium medium small medium">
          <div className={styles.heading}>
            <Heading level={4}>{title}</Heading>
            {resetLabel &&
              selected && (
                // eslint-disable-next-line react/button-has-type
                <button className={styles.reset} onClick={() => onSelect(undefined)}>
                  <Span size="regular">{resetLabel}</Span>
                </button>
              )}
          </div>
        </Spacer>
      </span>
    )}
    <ul className={styles.list}>
      {filters.map((option) => {
        const { id, name, count } = option;
        const renderCount = !!count || count === 0;
        return (
          <li key={`${id}-${parentId}`}>
            <Radio
              id={`${id}-${parentId}`}
              labelContent={() => (
                <span>
                  {name} {renderCount && <span className={styles.count}>({count})</span>}
                </span>
              )}
              isChecked={selected === id}
              isMuted={count === 0}
              onChange={() => onSelect(selected === id ? undefined : id, option)}
              isLabelLeft={isLabelLeft}
            />
          </li>
        );
      })}
    </ul>
  </React.Fragment>
);

FilterList.propTypes = {
  /* Id for filter list */
  id: PropTypes.string,

  /** The filter options */
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      count: PropTypes.number,
    }).isRequired,
  ).isRequired,

  /** The onSelect handler is passed in as a prop and takes the filter id as an argument */
  onSelect: PropTypes.func.isRequired,

  /** Optional title for the list */
  title: PropTypes.string,

  /** The currently selected filter */
  selected: PropTypes.string,

  /** If present, adds option to clear selected filter, labeled with the value of prop */
  resetLabel: PropTypes.string,

  /** Sets Input style render the label of the left and the iput in the right */
  isLabelLeft: PropTypes.bool,
};

FilterList.defaultProps = {
  id: undefined,
  title: undefined,
  selected: undefined,
  resetLabel: undefined,
  isLabelLeft: false,
};

export default FilterList;
